var _defs, _rect, _path, _polygon, _path2, _path3, _ellipse, _path4, _circle, _polygon2, _rect2, _rect3, _path5, _ellipse2, _ellipse3, _polygon3, _circle2, _rect4, _rect5, _rect6, _rect7, _path6, _path7, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#de8e68;}.cls-2{fill:#fcc486;}.cls-3{fill:#56cad8;}.cls-4{fill:#fed385;}.cls-5{fill:#d37c59;}.cls-6{fill:#fd8369;}.cls-7{fill:#74d5de;}.cls-8{fill:#dfdfdf;}.cls-9{fill:#f3f3f3;}.cls-10{fill:#fff;}.cls-11{fill:#fed892;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.32,
    y: 957.29,
    width: 29.31,
    height: 22.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1011.18,370.3c-3.3-2.48-28.39-38.35-34.73-63.83s-6.89,74.58-6.89,74.58l15.71,13.78Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1007.86 738.49 973.79 798.11 965.27 612.85 1019.57 614.63 1007.86 738.49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1043.14,360.78C1129.49,379,1102.63,578,1085.89,594.3s-140.1,19.33-152,5.7S934.77,337.89,1043.14,360.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1055.27,382.9c-1,6.62-40.08,1.91-38.38-7.19l9.94-53,38.38,7.2S1056.28,376.29,1055.27,382.9Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1039.68,
    cy: 296.55,
    rx: 54.17,
    ry: 38.97,
    transform: "translate(556.71 1263.82) rotate(-79.39)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1010.5,208.5c10.25,0,14.56,7,41,7,12.86,0,39,2.74,39,36,0,22.34,13,24,13,38,0,7-6.19,24-22,24-7,0-14-12-14-16s4-7,4-10c.08-14.45-46.73-22.48-49.85-35.48-3.39,3.11-11.19,12.7-14.1,18.91-4-2.05-3.54-5.38-8-8.43-3.85-2.61-15.85-9.29-15.85-22.59C983.65,233.3,990.54,208.5,1010.5,208.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1072.95,
    cy: 306.47,
    r: 12.53
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1083.22 596.29 1102.78 959.32 1066.99 959.32 971.73 618.4 971.73 597.62 1083.22 596.29"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 73,
    y: 208.9,
    width: 904.54,
    height: 667.49
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 73,
    y: 287.24,
    width: 904.54,
    height: 667.49
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1023.35,465.07c-8.31,4.29-20.37,10.45-28.68,26.8-10.45-1.88-62.45-11.26-99.7-10.72-3.48,7.5-9.38,19.3-7,20.91s78.8,33.5,132.4,28.67c7,.5,35.16-26,36.07-28.14S1023.35,465.07,1023.35,465.07Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 876.69,
    cy: 487.83,
    rx: 16.27,
    ry: 24.27,
    transform: "translate(164.12 1194.09) rotate(-73.84)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 899.68,
    cy: 172.66,
    rx: 25.77,
    ry: 22.05
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "627.91 416.4 296.17 416.4 296.17 954.73 749.87 954.73 749.87 538.36 627.91 416.4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 419.37,
    cy: 622.1,
    r: 52.66
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 500.33,
    y: 662.68,
    width: 179,
    height: 14.15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 366.71,
    y: 725.96,
    width: 312.63,
    height: 14.15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 366.71,
    y: 789.23,
    width: 312.63,
    height: 14.15
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 653.79,
    y: 163.74,
    width: 323.75,
    height: 149.76,
    rx: 24.54,
    ry: 24.54
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M653.79,188.28c0,11.32-34.84,99-220.35,99,0,18.9,230.1,9.37,230.1,9.37l3.4-106.54Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1102,415.69c23,25.92-33.5,100.44-44.39,97.36-12.83-3.63-51.87-40.17-52.18-52.82S1073.63,383.74,1102,415.69Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "1068.32 974.18 1068.32 992.81 1114.26 1051.15 1128 1044.47 1099.86 974.18 1068.32 974.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder2);
export default __webpack_public_path__ + "static/media/folder_2.ed88fb2406148dd57b33c2910674ce12.svg";
export { ForwardRef as ReactComponent };